<h1 mat-dialog-title>{{brand ? ('Editing Brand \"' + brand.name + '\"') : 'Add Brand'}}</h1>
@if (brand) {
  <h4>{{brand.id}}</h4>
}

<form [formGroup]="form" class="form">
  <mat-form-field appearance="outline">
    <mat-label>Name</mat-label>
    <input matInput formControlName="name">
  </mat-form-field>

  <mat-form-field appearance="outline">
    <mat-label>Account ID</mat-label>
    <input matInput formControlName="accountId">
  </mat-form-field>

  <mat-form-field appearance="outline" class="json-field">
    <mat-label>Configuration</mat-label>
    <app-json formControlName="config" baseTable="rewardsBrands" fieldHint="config"></app-json>
  </mat-form-field>

  <mat-form-field appearance="outline" class="json-field">
    <mat-label>Partner Filter Mode</mat-label>
    <app-json formControlName="partnerFilterMode" baseTable="rewardsBrands" fieldHint="partnerFilterMode"></app-json>
  </mat-form-field>

  <div class="buttons" mat-dialog-actions>
    <button mat-raised-button color="primary" [disabled]="form.invalid || saving" (click)="save()">Save</button>
    @if (brand) {
      <button mat-stroked-button color="warn" (click)="delete()">Delete</button>
    }
    <button mat-button (click)="cancel()">Cancel</button>
  </div>
</form>
